import { render } from "./PageHeader.vue?vue&type=template&id=684ebcd4&ts=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__